import Shape from '../models/Shape.js';

// src/sketches/habitSketch.js
export default function (p, kaleidical, width, height) {
    // Define all variables inside the sketch function to avoid global scope
    let activeKaleidical = kaleidical;
    let shapes = [];
    const symmetry = 6;
    let angle = 360 / symmetry;
    let rotationSpeed = 0.05;
    let newRotationSpeed = 0.05;
    let countDown = 100;
    const reflectionCount = 1;
    // let frameRateP;
    let scale = 1;
    let isFirstFrame = true;
    let firstFrameCallback = null;

    p.setup = function () {
        p.createCanvas(width, height, p.WEBGL);
        // frameRateP = p.createP('');
        p.angleMode(p.DEGREES);
        p.noStroke();

        for (const shapeInfo of activeKaleidical.shapes) {
            const code = shapeInfo.definition;
            const scale = shapeInfo.scale;
            const angle = shapeInfo.angle;
            const radius = shapeInfo.radius;
            const size = shapeInfo.size;
            const r = shapeInfo.r;
            const g = shapeInfo.g;
            const b = shapeInfo.b;
            const a = shapeInfo.a;

            const shape = new Shape(angle, radius, size, p.color(r, g, b, a), p, code);
            shape.updateScale(scale);

            shapes.push(shape);
        }
    };

    p.draw = function () {
        p.background(10, 10, 30);
        // frameRateP.html(`Frame Rate: ${p.round(p.frameRate())}`);

        p.scale(scale);

        if (countDown > 0) {
            countDown --;
        }

        p.rotate(p.frameCount * (countDown > 0 ? newRotationSpeed : rotationSpeed));

        for (let i = 0; i < symmetry; i++) {
            p.push();
            let theta = i * angle;
            p.rotate(theta);

            for (let r = 0; r < reflectionCount; r++) {
                p.push();

                let alpha = 1.0 / (r + 1.5);

                p.drawingContext.globalAlpha = alpha;

                drawShapesInSlice(0);

                p.push();
                p.scale(1, -1);
                drawShapesInSlice(0);
                p.pop();

                p.pop();
            }

            p.pop();
        }

        p.drawingContext.globalAlpha = 1.0;

        if (isFirstFrame) {
            if (firstFrameCallback) {
                firstFrameCallback();
            }
            isFirstFrame = false;
        }
    };

    function drawShapesInSlice(sliceRotation) {
        for (let shape of shapes) {
            shape.display(sliceRotation);
        }
    }

    p.updateScale = (newScale) => {
        scale = newScale;
    };

    p.setFirstFrameCallback = (callback) => {
        firstFrameCallback = callback;
    };

    p.setNewRotate = (speed) => {
        newRotationSpeed = speed;
        countDown = 100;
    };
}
